import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
export function Guarantee() {
  return <section className="bg-white px-4 py-6 sm:py-8" data-id="element-80" data-mp="1o3x23lbnuo1h">
      <div className="mx-auto max-w-3xl rounded-xl border border-sport/45 bg-canvas p-4 text-center shadow-sm" data-id="element-81" data-mp="1o3dmib9hgbqm">
        <p className="text-xs font-display font-bold uppercase tracking-widest text-electric" data-id="element-82" data-mp="221bw73cuzjzs">
          YOUR INVESTMENT IS 100% PROTECTED
        </p>
        <div className="mx-auto my-2 flex h-12 w-12 items-center justify-center rounded-full bg-electric/10" data-id="element-83" data-mp="19dz8uqyvj85f">
          <ShieldCheckIcon className="h-6 w-6 text-electric" aria-hidden="true" data-id="element-84" data-mp="14gz4qlll4fgy" />
        </div>
        <h2 className="text-xl font-extrabold uppercase text-navy sm:text-2xl" data-id="element-85" data-mp="1j6n6tp1lbi5q">
          🛡️ 7-Day Money-Back Guarantee
        </h2>
        <div className="mx-auto mt-2 max-w-2xl space-y-2 text-sm leading-relaxed text-graphite" data-id="element-86" data-mp="qnzrkq99yxck">
          <p data-id="element-87" data-mp="lpg1cdnnezee">Your purchase is completely risk-free.</p>
          <p data-id="element-88" data-mp="lowjsy1wud0w">
            Take seven full days to explore the entire system, review every
            module, organize your training sessions, implement the coaching
            resources, and start using the complete planning system with your
            athletes.
          </p>
          <p data-id="element-89" data-mp="yqmddo0nxtph">
            If for any reason you&apos;re not completely satisfied, simply
            contact us within the first 7 days and we&apos;ll refund 100% of
            your purchase.
          </p>
          <p className="font-display font-bold uppercase text-navy" data-id="element-90" data-mp="628df2q0knba">
            No risk. No questions asked.
          </p>
        </div>
      </div>
    </section>;
}